import PageService from 'services/page-service';
import utils from 'lib/utils';
import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import { LocalStorageService } from 'services/data-handler-services/web-storage-service';
import Backbone from 'backbone';
import Chaplin from 'chaplin';
import EF from 'ef/ef';

const NavigationService = {
  initialize: function () {
    Chaplin.mediator.subscribe('page:navigate', this.navigatePage, this);
    Chaplin.mediator.subscribe('window:navigate', this.navigateWindow, this);
    Chaplin.mediator.subscribe(
      'twine:navigate',
      evt => {
        this.navigatePage(evt.destination);
      },
      this
    );
  },

  navigatePage: function (destination) {
    const currPage = EF.module?.currentActivity?.currentPage;
    if (destination && currPage && currPage.get('navigation') && currPage.get('navigation')[destination]) {
      const newDestination = currPage.get('navigation')[destination];
      if (destination === 'back') {
        if (newDestination === 'browser') {
          this.navigateWindow(destination);
          return;
        } else {
          destination = newDestination;
        }
      }
    }
    let page;
    if (destination === 'skip') {
      destination = this.direction || 'forward';
    }

    this.direction = null;
    switch (destination) {
      case 'back':
        this.direction = 'back';
        page = PageService.getPreviousPage();
        if (!page && CourseSettingsService.get('menu').allowModuleBack) {
          // if first page in a module, let's go back to prev module
          const currentModuleId = EF.module.id;
          const currentModuleIdx = EF.modules.models
            .map(function (x) {
              return x.id;
            })
            .indexOf(currentModuleId);
          if (currentModuleIdx === 0 && CourseSettingsService.get('menu').skip) {
            // if it is a first page in first module and menu is disabled, let's exit the course
            window.postMessage({ event_type: 'close-content' }, window.location.origin);
            return;
          } else if (currentModuleIdx > 0) {
            const prevModule = EF.modules.models[currentModuleIdx - 1];
            const prevModuleLastActivity = prevModule.activities.models.slice(-1)[0];
            const prevModuleLastPage = prevModuleLastActivity.pages.models.slice(-1)[0];
            PageService.loadPage(prevModule.id, prevModuleLastActivity.id, prevModuleLastPage.id);
            page = prevModuleLastPage;
          }
        }
        break;
      case 'forward':
        if (
          !currPage.get('completed') &&
          !currPage.get('optional') &&
          !CourseSettingsService.get('preventPageSkipping') === false
        ) {
          Chaplin.mediator.publish(
            'action:alert',
            'skippingPrevented.messageType',
            'skippingPrevented.title',
            'skippingPrevented.message',
            '',
            true
          );
          return false;
        }
        this.direction = 'forward';
        page = PageService.getNextPage();
        if (!page && CourseSettingsService.get('menu').skip) {
          // if last page in a module, let's go to the first page of the next module
          const currentModuleIdx = EF.modules.indexOf(EF.module);
          const nextModule = EF.modules.at(currentModuleIdx + 1);
          const currentModuleLastActivity = EF.module.activities.at(EF.module.activities.length - 1);
          const currentModuleLastPage = currentModuleLastActivity.pages.at(currentModuleLastActivity.pages.length - 1);
          const islastPage = currentModuleLastPage.id === EF.module.currentActivity.currentPage.id;
          if (nextModule && islastPage) {
            const nextModuleFirstActivity = nextModule.activities.at(0);
            const nextModuleFirstPage = nextModuleFirstActivity.pages.at(0);
            PageService.loadPage(nextModule.id, nextModuleFirstActivity.id, nextModuleFirstPage.id);
            page = nextModuleFirstPage;
          }
        }
        break;
      case 'home':
        page = null;
        break;
      default:
        page = PageService.getPageByKey(destination);
    }

    EF.module.currentActivity.originPage = currPage.get('key');
    EF.module.currentActivity.destinationPage = page ? page.get('key') : null;

    if (currPage && (currPage.get('transition') || CourseSettingsService.get('transitionAll'))) {
      currPage.set('transition-out', destination === 'back' ? 'back' : 'forward');
      //console.log(`navigating away from ${currPage.get('key')}; setting transition-out to ${currPage.get('transition-out')}`);
    }

    if (page && (page.get('transition') || CourseSettingsService.get('transitionAll'))) {
      page.set('transition-in', destination === 'back' ? 'back' : 'forward');
      //console.log(`navigating to ${page.get('key')}; setting transition-in to ${page.get('transition-in')}`);
    }

    const navigate = function () {
      if (page) {
        utils.redirectToPage(page);
      } else {
        if (EF.module && CourseSettingsService.get('menu').type === 'group') {
          const group = EF.groups.find(function (group) {
            return group.get('id') === EF.module.get('group');
          });
          utils.redirectTo('controllers/menu#show', { type: group.get('key') });
        } else {
          utils.redirectTo('controllers/menu#show');
        }
      }
    };

    //console.log('publishing action:unload in navigation-service');
    if (page && page.get('transition-in')) {
      Chaplin.mediator.once('page:state:unloaded', navigate);
      Chaplin.mediator.publish('action:unload');
    } else {
      navigate();
    }
  },

  navigateWindow: function (destination) {
    if (destination === 'back') {
      window.history.back();
    } else {
      window.location.assign(destination);
    }
  },

  reload: function (view) {
    Backbone.history.stop(); // will be restarted by controllers/reload-controller
    LocalStorageService.setItem('originFragment', Backbone.history.fragment);
    Chaplin.utils.redirectTo({ url: 'reload' });
  },
};

export default NavigationService;
